<template>
  <div class="loginBox">
    <div class="loginLogoBox">
      <img src="./../../../assets/img/logo2.png" alt="" />
    </div>
    <div>
      <div class="loginFormBox">
        <div class="loginForm">
          <div class="loginTabsBox">
            <div @click="isPhoneLoad = false" :class="{ isSelectTabs: !isPhoneLoad }">
              账号登录
            </div>
            <div @click="isPhoneLoad = true" :class="{ isSelectTabs: isPhoneLoad }">
              短信登录
            </div>
          </div>
          <!-- 当前为账号登录 -->
          <template v-if="!isPhoneLoad">
            <el-input class="styleBox" v-model="submitObj.username" placeholder="请输入用户名/证件号码"></el-input>
            <el-input class="styleBox" v-model="submitObj.password" show-password placeholder="请输入密码"></el-input>
            <!-- <el-row type="flex" class="styleBox" justify="space-between">
              <el-col>
                <el-input
                  class="captchaBox"
                  v-model="submitObj.captcha"
                  placeholder="验证码"
                ></el-input>
              </el-col>
              <el-col>
                <img :src="captchaPayh" @click="getCaptcha" alt="" />
              </el-col>
            </el-row> -->
          </template>
          <!-- 当前为手机短信登录 -->
          <template v-else>
            <el-input class="styleBox" v-model="phontObj.username" placeholder="请输入用户名/证件号码"></el-input>
            <el-row type="flex" class="styleBox" justify="space-between">
              <el-col>
                <el-input style="width:200px" v-model="phontObj.verifyCode" placeholder="请输入短信验证码"></el-input>
              </el-col>
              <el-button :disabled="isSendSms" @click="getSendSma" type="primary">
                {{ this.isSendSms ? this.totalTime + 's后重新获取' : '获取短信验证码' }}
              </el-button>
            </el-row>
          </template>
          <Debounce>
            <el-button class="styleBox" @click="login" type="primary">登录</el-button>
          </Debounce>
          <div class="logFootBox">
            <el-button @click="$router.push({ path: '/setPassword' })" type="text">忘记密码?</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      submitObj: {
        username: '',
        password: '',
        captcha: ''
      },
      phontObj: {
        username: '',
        verifyCode: ''
      },
      totalTime: 60,
      isSendSms: false, //当前是否已经发送短信
      captchaPayh: '',
      isPhoneLoad: false //false 为默认,账号登录,true为短信登录
    };
  },
  created() {
    window.addEventListener('keydown', this.keyDown);
  },
  mounted() {
    // this.getCaptcha();
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false);
  },
  methods: {
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.login();
      }
    },
    //短信登陆
    loginBySms() {
      if (!this.phontObj.username) {
        this.$message({
          type: 'warning',
          message: '请输入用户名/证件号码!',
          duration: 1000
        });
        return;
      }
      if (!this.phontObj.verifyCode) {
        this.$message({
          type: 'warning',
          message: '请输入短信验证码!',
          duration: 1000
        });
        return;
      }
      this.phontObj.type = 0;
      this.$axios
        .post("/login/applet/msg", this.phontObj)
        .then(res => {
          this.$store.commit('setUser', res.data.data);
          this.$message({
            type: 'success',
            message: '登录成功!',
            duration: 600
          });
          this.$router.push({ path: '/admin' });
        })
    },
    //账号登录
    loginByAccount() {
      if (!this.submitObj.username) {
        this.$message({
          type: 'warning',
          message: '请输入用户名/证件号码!',
          duration: 1000
        });
        return;
      }
      if (!this.submitObj.password) {
        this.$message({
          type: 'warning',
          message: '请输入密码!',
          duration: 1000
        });
        return;
      }
      this.submitObj.type = 0;
      this.$axios
        .post("/login/applet/user", this.submitObj)
        .then(res => {
          this.$store.commit('setUser', res.data.data);
          this.$message({
            type: 'success',
            message: '登录成功!',
            duration: 600
          });
          this.$router.push({ path: '/admin' });
        })
    },
    login() {
      if (this.isPhoneLoad) {
        this.loginBySms();
      } else {
        this.loginByAccount();
      }
    },
    getCaptcha() {
      this.$axios
        .get('/login/captcha.jpg', {
          responseType: 'arraybuffer'
        })
        .then(response => {
          return (
            'data:image/png;base64,' +
            btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
          );
        })
        .then(res => {
          this.captchaPayh = res;
        })
        .catch(res => {
          console.log(res);
        });
    },
    getSendSma() {
      if (this.isSendSms) return;
      if (!this.phontObj.username) {
        this.$message.warning({ message: '请输入用户名/身份账号!', duration: 1000 });
        return;
      }
      this.$axios
        .post('/login/sendBindingSms/' + this.phontObj.username)
        .then(res => {
          this.isSendSms = true;
          let { code } = res.data;
          this.$message.success({ message: '短信已经发送!', duration: 1000 });
          if (code == 10000) {
            let clock = window.setInterval(() => {
              this.totalTime--;
              if (this.totalTime < 0) {
                window.clearInterval(clock);
                this.totalTime = 60;
                this.isSendSms = false; //这里重新开启
              }
            }, 1000);
          }
        })
        .catch(err => {
          this.isSendSms = false; //这里重新开启
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.loginBox {
  width: 100vw;
  height: 100vh;
  background-image: url("./../../../assets/img/loginBgImg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .loginLogoBox {
    padding-left: 40px;
    padding-top: 60px;
    img {
      height: 80px;
    }
  }
  .loginFormBox {
    margin-top: 100px;
    margin-left: 200px;
    width: 500px;
    padding: 8px;
    background-color: rgba(255, 255, 255, 0.2);
    .loginForm {
      background-color: white;
      border: 2px solid #409eff;
      padding: 10% 15%;
      .logFootBox {
        display: flex;
        flex-direction: row-reverse;
      }
      .loginTabsBox {
        display: flex;
        justify-content: space-around;
        div {
          padding: 5px;
          font-size: 22px;
          cursor: pointer;
        }
        .isSelectTabs {
          font-weight: bolder;
          color: #409eff;
          border-bottom: 4px solid #409eff;
          transform: scale(1.1);
        }
      }
      p {
        font-size: 24px;
        font-weight: 700;
        text-align: center;
      }
      .styleBox {
        width: 100%;
        margin-top: 8%;
      }
      .captchaBox {
        width: 140px;
      }
      img {
        border: 1px solid rgb(244, 244, 244);
        height: 80%;
        cursor: pointer;
      }
    }
  }
}
</style>
